import React, {Component} from 'react';
import { Redirect } from 'react-router-dom';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';

import SpogRoute from 'routes/SpogRoute';
import NoAuthorized from 'routes/NoAuthorized';

const PrivateRouteInner = ({ component: AComponent, authorized, extra, ...rest }) => (
    <SpogRoute
        {...rest}
        render = {
            props => {
                if (AComponent) {
                    if (rest.auth.isLoggedIn) {
                        if (authorized) {
                            return <AComponent {...props}/>;
                        }

                        return <NoAuthorized service={extra.service} />;

                    }

                    return (
                        <Redirect to={{
                            pathname: '/login',
                            state:    { from: props.location }
                        }}/>
                    );

                }

                return null;
            }
        }
    />
);

/** Route to render a route when user is authorized */
class PrivateRoute extends Component {
    render() {
        return <PrivateRouteInner {...this.props} />;
    }
}

const mapStateToProps = state => ({
    auth: state.auth
});

export default injectIntl(connect(mapStateToProps)(PrivateRoute));



// WEBPACK FOOTER //
// ./src/routes/PrivateRoute.jsx